/**
 * 计算字符串的字节长度
 * @param str 需要计算的字符串
 * @returns 字节长度
 */

// 计算字符串按GBK编码的字节长度（中文2字节，英文1字节）
export const getByteLength = (str: string): number => {
  let byteLength = 0;
  for (let i = 0; i < str.length; i++) {
    const charCode = str.charCodeAt(i);
    // 大于0x00ff的字符为中文等宽字符，占2字节
    byteLength += charCode > 0x00ff ? 2 : 1;
  }
  return byteLength;
};
